(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
  },{threshold:.14});
  document.querySelectorAll('.es-reveal').forEach(function(el){ io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-anniversary-song"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
  },{threshold:.14});
  document.querySelectorAll('.es-reveal').forEach(function(el){ io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-birthday-song"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
  },{threshold:.14});
  document.querySelectorAll('.es-reveal').forEach(function(el){ io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-memorial-song"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
  },{threshold:.14});
  document.querySelectorAll('.es-reveal').forEach(function(el){ io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-wedding-song"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
  },{threshold:.14});
  document.querySelectorAll('.es-reveal').forEach(function(el){ io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["first-dance-song"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
  },{threshold:.14});
  document.querySelectorAll('.es-reveal').forEach(function(el){ io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["personalized-song-gift"] && !Shopify.designMode) return;
  try {
    
(function(){
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target);} });
  },{threshold:.14});
  document.querySelectorAll('.es-reveal').forEach(function(el){ io.observe(el); });
})();

  } catch(e) { console.error(e); }
})();
})();
